export default __webpack_public_path__ + "static/media/QR.55f32388.jpg";